import { createContext } from 'react';
import type RootStore from 'stores/rootStore';

// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
const StoreContext = createContext<RootStore>(null!);
export default StoreContext;
